var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeams(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 6,
    r: 4.667,
    fill: "#7b83eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.667 7H12.44l.021.093.002.008.022.086A4.671 4.671 0 0018 10.559V8.333A1.337 1.337 0 0016.667 7z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.667 8h-2.884A4.667 4.667 0 0017 10.667V9.333A1.337 1.337 0 0015.667 8z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 7.5,
    r: 3.5,
    fill: "#5059c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 12h-7.861a.64.64 0 00-.64.64v8.11a5.121 5.121 0 003.967 5.084A5.006 5.006 0 0032 20.938V13.5a1.5 1.5 0 00-1.5-1.5z",
    fill: "#5059c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 13.5V23a7.995 7.995 0 01-14.92 4 7.173 7.173 0 01-.5-1 8.367 8.367 0 01-.33-1A8.24 8.24 0 019 23v-9.5a1.498 1.498 0 011.5-1.5h13a1.498 1.498 0 011.5 1.5z",
    fill: "#7b83eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.667 8h-2.884A4.667 4.667 0 0017 10.667V9.333A1.337 1.337 0 0015.667 8z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 12v12.67a1.32 1.32 0 01-1.04 1.29.966.966 0 01-.29.04H9.58a8.367 8.367 0 01-.33-1A8.24 8.24 0 019 23v-9.5a1.498 1.498 0 011.5-1.5z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 12v13.67a.967.967 0 01-.04.29A1.32 1.32 0 0115.67 27h-5.59a7.173 7.173 0 01-.5-1 8.367 8.367 0 01-.33-1A8.24 8.24 0 019 23v-9.5a1.498 1.498 0 011.5-1.5z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 12v11.67A1.336 1.336 0 0115.67 25H9.25A8.24 8.24 0 019 23v-9.5a1.498 1.498 0 011.5-1.5z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12A1.498 1.498 0 009 13.5V23a8.24 8.24 0 00.25 2h5.42A1.336 1.336 0 0016 23.67V12z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.333 8h13.334A1.333 1.333 0 0116 9.333v13.334A1.333 1.333 0 0114.667 24H1.333A1.333 1.333 0 010 22.667V9.333A1.333 1.333 0 011.333 8z",
    fill: "#4b53bc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.98 12.975H8.99v8.02H7.028v-8.02H4.02v-1.97h7.96z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeams);
export default __webpack_public_path__ + "static/media/teams.1a7e7387b438db4c6ec9a0dfc7c3df5f.svg";
export { ForwardRef as ReactComponent };